import React, { useState } from 'react'
import cn from 'classnames'

import Button from './Button'

import styles from './QuantityEntryModal.module.scss'
import { replace, slice } from 'lodash'

const QuantityEntryModal = ({ id, oldQuantity, onClose, className, updateCartItemQuantity }) => {
  const classNames = cn(styles.quantityEntryModal, className)
  const [newQuantity, setNewQuantity] = useState('')

  const handleUpdateQuantity = () => {
    updateCartItemQuantity(parseInt(newQuantity, 10))
    onClose()
  }

  const handleInput = (event) => {

    //If Enter was pressed, submit the entered value
    if(event.key === 'Enter' || event.keyCode === 13) {
      handleUpdateQuantity()
      return
    }

    let input = event.target.value?.replace(/\D/g, '');

    // Save the current cursor position before updating the value
    setNewQuantity(input?.slice(-3));
  }

  return (
    <div className={classNames}>
      <div className={styles.overlay}></div>
        <div className={styles.content}>
          <div className={styles.body}>
            <p className={styles.text}>Custom Quantity</p>
            <div className={styles.inputContainer}>
              <input
                type="tel"
                placeholder={oldQuantity}
                value={`${newQuantity}`}
                onChange={handleInput}
                pattern="\d*"
                autoFocus
              />
            </div>
            <Button className={cn(styles.button, styles.doneButton)} onClick={handleUpdateQuantity}>Set Quantity</Button>
            <Button className={cn(styles.button, styles.cancelButton)} onClick={onClose}>Cancel</Button>
        </div>
      </div>
    </div>
  )
}

export default QuantityEntryModal
